// extracted by mini-css-extract-plugin
module.exports =  {"bottom":"vzXNOASiVpYraEmuxxW4","buildingButton":"xp_Iajdmf8SosIdSPHru"};